import { cn } from '@blockworks/ui/utils';

interface IChartTabs {
    tabs: any[];
    onClick: any;
}

const ChartTabs = (props: IChartTabs) => {
    const { tabs, onClick } = props;

    return (
        <nav className="flex justify-around bg-gray-100 p-1" aria-label="Tabs">
            {tabs.map((tab: any) => (
                <a
                    key={tab.name}
                    className={cn(
                        tab.current ? 'bg-white text-gray-600' : 'text-gray-600',
                        'px-2 py-1 font-medium text-sm hover:cursor-pointer',
                    )}
                    aria-current={tab.current ? 'page' : undefined}
                    onClick={onClick}
                >
                    {tab.name}
                </a>
            ))}
        </nav>
    );
};

export default ChartTabs;
